<template>
  <div class="hori-screen-container">
    <i class="icon-lily icon-lily-hengping"></i>
    <h1>请横屏使用网站</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.hori-screen-container
  height 100vh
  display flex
  justify-content center
  align-items center
  flex-direction column
  .icon-lily-hengping
    font-size 180px
    color #cdcdcd
  h1
    font-size 42px
    font-weight 400
    color #cdcdcd
</style>>